<template>
  <ScreenWidthProvider
    v-slot="{ isWider }"
    class="media-logo-card overflow-hidden"
  >
    <div class="flex flex-wrap">
      <div class="w-full md:w-7/12 bg-transparent flex flex-col p-0">
        <button
          class="bg-transparent p-0 min-h-[250px] h-full relative"
          @click="showMediaModal"
        >
          <ResponsiveImage
            v-if="media.type === 'image'"
            class="size-full top-0 left-0"
            position="absolute"
            :image="media.location"
            :type="media.type"
            :aspect-ratio="false"
            :alt="title"
            cover
          />
          <MediaPlayer
            v-if="media.type === 'youtube'"
            class="size-full !absolute top-0 left-0"
            :url="media.location"
            :custom-thumbnail="media.customThumbnail"
            :aspect-ratio="false"
            thumbnail-class="object-cover size-full"
            just-preview
            :alt="title"
          />
        </button>
      </div>
      <div class="md:w-5/12 grow p-0">
        <div class="md:px-4 size-full flex flex-col items-start">
          <div class="flex md:flex-col">
            <div class="overflow-hidden pr-4 md:mr-0 mb-4 w-min-fit-content">
              <ResponsiveImage
                class="media-logo-card__logo"
                :alt="logo.alt || title"
                :image="logo.url"
                :type="logo.type"
                fit="contain"
                :clip="false"
                background-color="white"
              />
            </div>
            <i-horizontal-dashed-line
              v-if="isWider('md', 1)"
              filled
              :font-controlled="false"
              width="100%"
            />
            <div class="pt-4 pb-0 pl-4 md:pl-0 -mb-1 md:mb-0 md:py-5">
              <h4
                class="mb-1 font-serif"
                :data-translation="titleTranslationKey"
              >
                {{ title }}
              </h4>
              <h4
                v-if="titleBy"
                class="ml-2 mb-6 font-serif font-italic font-normal"
              >
                <span>
                  – {{ ' ' }}
                </span>
                <span :data-translation="titleByTranslationKey">
                  {{ titleBy }}
                </span>
              </h4>
              <p
                class="mb-0 hidden md:block"
                :data-translation="textTranslationKey"
              >
                {{ text }}
              </p>
            </div>
          </div>
          <i-horizontal-dashed-line
            filled
            :font-controlled="false"
            width="100%"
          />
          <p
            class="mt-4 pt-1 md:hidden"
            :data-translation="textTranslationKey"
          >
            {{ text }}
          </p>
        </div>
      </div>
    </div>
    <LazyMediaModal
      v-if="mediaModalVisible"
      visible
      :media-list="[media]"
      size="lg"
      autoplay
      centered
      @on-hide="hideMediaModal"
    />
  </ScreenWidthProvider>
</template>

<script>
export default defineNuxtComponent({
  props: {
    /**
     * @prop {{
     *   url: string
     *   alt: string
     *   type: string
     * }}
     */
    logo: {
      type: Object,
      required: true,
    },

    title: {
      type: String,
      default: null,
    },

    titleTranslationKey: {
      type: String,
      default: null,
    },

    titleBy: {
      type: String,
      default: null,
    },

    titleByTranslationKey: {
      type: String,
      default: null,
    },

    text: {
      type: String,
      default: null,
    },

    textTranslationKey: {
      type: String,
      default: null,
    },

    media: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return {
      mediaModalVisible: false,
    }
  },

  methods: {
    showMediaModal () {
      this.mediaModalVisible = true
    },

    hideMediaModal () {
      this.mediaModalVisible = false
    },
  },
})
</script>

<style lang="scss" scoped>
/*! purgecss start ignore */
.media-logo-card {
  &__logo {
    height: 300px;
    width: 300px;
    margin: -75px 0 -80px -70px;

    @media (max-width: calc(theme('screens.md') - 1px)) {
      height: 200px;
      width: 200px;
      margin: -45px -45px -60px -44px;
    }
  }

  h4 {
    font-size: 1.2rem;
  }
}
/*! purgecss end ignore */
</style>
